export default __webpack_public_path__ + "static/RunLeft9-2e0fd987d495a443db6ab8975e01c14c.mp3";